<template>
  <div class="create-scene">
    <div class="create-scene-header">
      <i @click="toBack" class="el-icon-arrow-left"></i>
      <span>请选择您的使用场景</span>
    </div>
    <div class="create-scene-body">
      <div class="create-scene-main">
        <div @click="currentScene(item)" v-for="item in surveyList.filter(it=>!['MakeCollections','LandingPage'].includes(it.value))" :key="item.value" class="scene-item flex">
          <!-- <img class="scene-icon-img" :src="item.src" /> -->
          <img class="scene-icon-img" :src="`${baseUrl}/assets/img/scene/svg/icon-${item.value}.svg`"  />
          <div class="scene-item-content">
            <h3>{{item.label}}</h3>
            <p>{{item.tips}}</p>
          </div>
        </div>
        <!-- 2023-6-1 下线 <div v-if="!enabledConfig" @click="goChatGPT" class="scene-item flex">
          <img class="scene-icon-img" :src="`${baseUrl}/assets/img/scene/svg/icon-chatGPT.svg`" />
          <i class="icon-font icon-ClockIn"></i>
          <div class="scene-item-content">
            <h3>ChatGPT</h3>
            <p>免费注册直接使用</p>
          </div>
        </div> -->
      </div>
      <div class="create-scene-secondary" v-custom:create-scene="'out_D16'">
        <p>以下功能场景即将上线，如有需要，请
          <el-popover
          placement="bottom"
          width="142"
          popper-class="popover-style"
          trigger="hover"
          content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
          <div class="popover-img">
            <img :src="baseUrl + '/assets/img/code/Customer.Service.png'" alt="联系客服" />
            <p>请微信扫码联系客服咨询</p>
          </div>
          <span slot="reference">联系客服</span>
        </el-popover>
          </p>
        <div class="create-scene-main">
          <div v-for="item in surveyList.filter(it=>['MakeCollections','LandingPage'].includes(it.value))" :key="item.value" class="scene-item flex">
            <!-- <img class="scene-icon-img" :src="item.src" /> -->
            <img class="scene-icon-img" :src="`${baseUrl}/assets/img/scene/svg/icon-${item.value}.svg`"  />
            <div class="scene-item-content">
              <h3>{{item.label}}</h3>
              <p>{{item.tips}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ManualInputDialog :visible.sync="visible"/>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { SurveyList }  from '@/assets/js/config/survey-config.js'
  import { wjSceneTypeListAll } from '@/api/wenjuan/wjquestion.js'
  import GlobalConfig from '@/global/config.js'
  import { getSurveyDomain } from '@/assets/js/config/env'
  import ManualInputDialog from '@/question/components/popup/ManualInputDialog'
  export default {
    name:'createScene',
    components:{ManualInputDialog},
    data(){
      return {
        surveyList:[],
        baseUrl: getSurveyDomain(),
        visible: false
      }
    },
  computed: {
    ...mapGetters(['configContextMap', 'enabledConfig']),
    enableChose() {
      let config = this.configContextMap.get('create-scene')?.out_D16
      return config ? config === "1" : true
    }
  },
    methods:{
      init(){
        console.log('this.baseUrl',this.baseUrl)
      },
      toBack(){
        this.$router.back()
      },
      // 点击
      currentScene(item){
        if(item.value === "Mcaf") {
          const companyId=GlobalConfig.getCompanyId()
          const baseId=this.$store.getters.userInfo?.baseId
          let url=`${process.env.VUE_APP_MCAF_DOMAIN_NEW}/cp/pl-dygc/create_project?token=${GlobalConfig.getBaseToken()}&sfId=${baseId}&companyId=${companyId}&comp=cp_createPro`
          window.open(url)
          return
        }
        if(item.value === "entrustInput") {
          this.visible = true
          return
        }
        this.$router.push({
          path: '/create-survey',
          query:{scene:item.value}
        })
      },
      getSceneType(){
        wjSceneTypeListAll().then(res => {
          // console.log('res', res)
          if(res.data.code === 0){
            this.surveyList = this.enableChose ? res.data.data : [res.data.data[0]];
            console.log('this.surveyList', this.surveyList)
          }
          this.surveyList = this.surveyList.concat([
            {
              id: (this.surveyList[this.surveyList.length-1]?.id??0)+1,
              label: "人工录入问卷",
              sceneType: 11,
              src: '',
              tips: "开通付费年会员，享免费录入服务",
              value: "entrustInput"
            }
          ]).filter(item => item.label!=='明察暗访')
        })
      },
      goChatGPT(){
        window.open(process.env.VUE_APP_AIGC + `?token=${GlobalConfig.getBaseToken()}`)
      }
    },
    mounted(){
      this.getSceneType();
    }
  }
</script>

<style lang="scss" scoped>
.create-scene{
  background: #F7F9FB;
  width: 100%;
  height: 100%;
  .create-scene-header{
    margin: 0 auto;
    width: 1200px;
    padding-top: 23px;
    display: flex;
    justify-content: center;
    position: relative;
    i{
      background: #a5b4cc;
      border-radius: 50%;
      position: absolute;
      top: 23px;
      left: 0px;
      display: inline-block;
      height: 24px;
      width: 24px;
      cursor: pointer;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      color: #fff;
    }
    span{
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 20px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 22px;
    }
  }
  .create-scene-body{
    margin: 24px auto;
    width: 1200px;
    .create-scene-main{
      display: grid;
      grid-template-columns: repeat(3, 390px);
      grid-template-rows: 110px;
      grid-gap: 15px 15px;

      .scene-item{
        box-shadow: 0 1px 4px 0 rgba(0,0,0,0.06);
        background: #fff;
        width: 390px;
        height: 110px;
        padding: 33px 64px;
        box-sizing: border-box;
        cursor: pointer;
        .scene-icon-img{
          width: 44px;
          height: 44px;
        }
        .scene-item-content{
          margin-left: 12px;
          h3{
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: rgba(0, 0, 0,0.85);
          }
          p{
            color: rgba(0, 0, 0,0.45);
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            line-height: 22px;
            margin-top: 2px;
          }
        }
      }
    }
    .create-scene-secondary{
      p{
        margin-top: 24px;
        margin-bottom: 15px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        font-family: PingFangSC;
        font-weight: 400;
        line-height: 22px;
      }
      span{
        color: rgba(39, 117, 232, 1);
        font-size: 16px;
        font-family: PingFangSC;
        font-weight: 400;
        line-height: 22px;
      }
    }
  }
}
</style>
<style lang="scss">
.popover-style{
  padding: 0;
  .popover-img{
     width: 110px;
     margin: 16px auto 8px;
     img{
       width: 110px;
       height: 110px;
       margin-bottom: 8px;
     }
     p{
       height: 32px;
       width: 100%;
       text-align: center;
       font-family: PingFangSC-Regul;
       font-size: 14px;
       font-weight: 400;
       line-height: 1rem;
       margin: 0 auto;
       color: rgba(0,0,0,.85);
       padding: 0 3px;
       margin-bottom: 0;
     }
   }
}
</style>
